import { useState, useEffect } from 'react';
import useOuterClick from '../../../utils/hooks/useOuterClick';
import S from './DropdownStyles';

function Dropdown({
  target, children, contentClassName, isOpen, onChange = () => {},
}: any): JSX.Element {
  const [dropdownIsOpen, toggleDropdownState] = useState(false);

  const innerRef = useOuterClick(() => {
    if (dropdownIsOpen) {
      toggleDropdownState(false);
      onChange(false);
    }
  });

  useEffect(() => {
    if (isOpen !== dropdownIsOpen && isOpen !== undefined) {
      toggleDropdownState(isOpen);
    }
  }, [isOpen]);

  const handleToggleDropdown = (toggler: boolean): void => {
    toggleDropdownState(toggler);
    onChange(toggler);
  };

  return (
    <S.Wrapper
      ref={innerRef}
    >
      <S.TargetWrapper
        onClick={() => handleToggleDropdown(true)}
      >
        {target}
      </S.TargetWrapper>
      <S.ContentWrapper
        className={`${contentClassName} ${dropdownIsOpen ? 'open' : 'closed'}`}
      >
        {children}
      </S.ContentWrapper>
    </S.Wrapper>
  );
}

export default Dropdown;
